import { render, staticRenderFns } from "./enquiry.vue?vue&type=template&id=195a6dc7&scoped=true"
import script from "./enquiry.vue?vue&type=script&lang=js"
export * from "./enquiry.vue?vue&type=script&lang=js"
import style0 from "./enquiry.vue?vue&type=style&index=0&id=195a6dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a6dc7",
  null
  
)

export default component.exports